const state = {
    prodRecipeInfoLijst: [],
    prodIngrProdInfoLijst: []
};

export default state;
